const useStyles = {
  icon: {
    height: '24px',
    width: '24px',
  },
}

export default useStyles
